import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { toDateFormat } from 'utils/helpers/timestampHelper';

class WorkoutLastLog extends React.Component {
  render() {
    let { workoutLog, clientId } = this.props;
    let isWorkoutLogPresent = workoutLog && !!Object.keys(workoutLog).length
    let assignedAt = isWorkoutLogPresent && workoutLog.created_at
                      && moment(toDateFormat(workoutLog.created_at)).format('L');
    return (
      <div className="workout-item workout-last-log">
        <p>
          <Link to={`/clients/${clientId}/workout-history`}>
            Last Logged{isWorkoutLogPresent && ':'} {assignedAt} <br />
            {isWorkoutLogPresent && `${workoutLog.name}, ${workoutLog.level} Phase ${workoutLog.phase}`}
          </Link>
        </p>
      </div>
    );
  }
}

export default WorkoutLastLog;
